import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VaFilesComponent } from './files.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [VaFilesComponent],
  exports: [VaFilesComponent],
})
export class VaFilesModule {}
